import React from 'react'
import { Container } from 'react-bootstrap'
import Typography from '../../../../components/Typography/Typography'

const InfoLine = ({ text }) => {
    return (
        <Container fluid className="d-flex align-items-center">
            <div className="border-top w-100 opacity-50" />
            <Typography variant={'desc'} color={'whiteTransparent'} className="text-nowrap mx-3">
                {text}
            </Typography>
            <div className="border-top w-100 opacity-50" />
        </Container>
    )
}

export default InfoLine
